import { render, staticRenderFns } from "./ContactApproveListTable.vue?vue&type=template&id=059b3a14&scoped=true"
import script from "./ContactApproveListTable.vue?vue&type=script&lang=js"
export * from "./ContactApproveListTable.vue?vue&type=script&lang=js"
import style0 from "./ContactApproveListTable.vue?vue&type=style&index=0&id=059b3a14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059b3a14",
  null
  
)

export default component.exports